module.exports = __webpack_public_path__ + "img/img_placeholder.34d4b154.svg";